import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTorch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTorch"><Path fillRule="evenodd" clipRule="evenodd" d="M18.6338 14.2793L17.9717 14.9424L17.6416 14.9902L14.4707 15.4424L7 22.9141L1.08594 17L8.55664 9.52832L9.00977 6.3584L9.05762 6.02832L9.91797 5.16699L18.6338 14.2793ZM8.79297 13.793L10.207 15.207L12.707 12.707L11.293 11.293L8.79297 13.793Z" fill="currentColor"/><Path d="M22.9141 10L19.8369 13.0762L11.1211 3.96387L14 1.08594L22.9141 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTorch;
